<template>
  <div class="navtab">
    <div class="navtab__box">
      <p class="navtab__box--title">
        Travel notes
      </p>
      <div v-for="blog in blogList" :key="blog.id">
        <!-- <app-link :id="blog.linkId" :type="blog.linkType" class="navtab__box--list link-unstyle">{{ blog.name }}</app-link> -->
        <a :href="blog.url" class="navtab__box--list link-unstyle">{{ blog.name }}</a>
      </div>
    </div>
    <div class="navtab__box">
      <p class="navtab__box--title">
        Guides
      </p>
      <div v-for="guide in guideList" :key="guide.id">
        <app-link :id="guide.linkId" :type="guide.linkType" class="navtab__box--list link-unstyle">
          {{ guide.name }}
        </app-link>
      </div>
    </div>
    <div class="navtab__box">
      <p class="navtab__box--title">
        Collections
      </p>
      <div v-for="collection in collectionsList" :key="collection.id">
        <app-link :id="collection.linkId" :type="collection.linkType" class="navtab__box--list link-unstyle">
          {{ collection.name }}
        </app-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      blogList: [
        // {
        //   id: 1,
        //   name: 'History and Culture',
        //   linkType: 'blog',
        //   linkId: 3137,
        //   url: '/blog/History-and-Culture',
        // },
        // {
        //   id: 2,
        //   name: 'Food and Drink',
        //   linkType: 'blog',
        //   linkId: 3130,
        //   url: '/blog/Food-and-Drink',
        // },
        // {
        //   id: 3,
        //   name: 'Inspiration',
        //   linkType: 'blog',
        //   linkId: 3186,
        //   url: '/blog/Inspiration',
        // },
        // {
        //   id: 4,
        //   name: 'Resources',
        //   linkType: 'blog',
        //   linkId: 129,
        //   url: '/blog/Resources',
        // },
        // {
        //   id: 4,
        //   name: 'Wellness and Relaxation',
        //   linkType: 'blog',
        //   linkId: 129,
        //   url: '/blog/Wellness-and-Relaxation',
        // },
        // {
        //   id: 5,
        //   name: 'Activities and Adventure',
        //   linkType: 'page',
        //   linkId: 129,
        //   url: '/blog/Activities-and-Adventure',
        // },
        {
          id: 6,
          name: 'Explore our blog',
          linkType: 'page',
          linkId: 1049,
          url: '/blog',
        },
      ],
      guideList: [
        {
          id: 1,
          name: 'Sicily',
          linkType: 'page',
          linkId: 33,
        },
        {
          id: 2,
          name: 'Puglia',
          linkType: 'page',
          linkId: 34,
        },
        {
          id: 4,
          name: 'Tuscany',
          linkType: "page",
          linkId: 1293
        },
        {
          id: 5,
          name: 'Greece',
          linkType: 'page',
          linkId: 1087,
        },
        {
          id: 6,
          name: 'Corsica',
          linkType: 'page',
          linkId: 36,
        },
      ],
      collectionsList: [
        {
          id: 1,
          name: 'Think Exquisite',
          linkType: 'collection',
          linkId: 439,
        },
        {
          id: 2,
          name: 'With a gate to the sea',
          linkType: 'collection',
          linkId: 518,
        },
        {
          id: 3,
          name: 'Family favourites',
          linkType: 'page',
          linkId: 882,
        },
        {
          id: 4,
          name: 'A little place we know',
          linkType: 'collection',
          linkId: 616,
        },
      ],
    };
  },
  computed: {
    // isSearchTouched() {
    //   return this.$store.getters.getSearchTouch;
    // },
  },
  methods: {
    getAppLinkByID(pageID, ptype) {
      return this.$store.getters['applinks/getLink'](ptype, pageID).url;
    },
  },
};
</script>
